export default __webpack_public_path__ + "static/media/AquaMare.1a5a46f1.png";